module.exports = __webpack_public_path__ + "img/level4.png";